import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=0f94f8fa&scoped=true"
import script from "./CardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CardHeader.vue?vue&type=style&index=0&id=0f94f8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94f8fa",
  null
  
)

export default component.exports